import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { Theme } from "../../config";

type ServiceCardProps = {
  title: string;
  icon: string;
  alt: string;
  cta: string;
  href: string;
  style?: React.CSSProperties; // Add style prop with optional React.CSSProperties type
};

const ServicesCard: React.FC<ServiceCardProps> = ({
  icon,
  alt,
  title,
  cta,
  href,
  style, // Destructure style from props
}) => {
  return (
    <Paper
      sx={{
        ...style, // Spread the style prop into the Paper component's sx prop
        maxWidth: { xs: '100%', sm: '25rem' },
        width: '100%',
        backgroundColor:"rgb(30, 118, 120)",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        p: 2,
        borderRadius: '10px',
        // color: "white"
      }}
    >
      <Box
        component="img"
        src={icon}
        alt={alt}
        sx={{
          width: '12rem',
          height: '10rem'
        }}
      />
      <Typography variant='h3' component='h3' my={4}>{title}</Typography>

      {cta && (
        <a href={href} target='_blank' rel='noopener noreferrer'>
          <Button
            // style={{ backgroundColor: "white", color: "#740000", fontWeight: 700 }}
            variant='contained'
            color='primary'
            size='large'
          // className='client-login__card__cta'
          >
            {cta}
          </Button>
        </a>
      )}
    </Paper>
  );
};

export default React.memo(ServicesCard);
